export default __webpack_public_path__ + "static/button-alignment-modal-0f75c98d36b6fc530b74fe54d56b6cc8.png";